import { ORDER_HISTORY_REPORT_IDS_API } from 'constants/AppConstants';
import { retryAPI } from 'utils/app.utils';

export default async (requestBody) => {
  try {
    const response = await retryAPI(() => fetch(
      ORDER_HISTORY_REPORT_IDS_API,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      },
    ));
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };

    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
